import React from 'react'
import { Chart as ChartJS } from "chart.js/auto";
import { Bar } from "react-chartjs-2";
import { bar_chart } from '../../screens/redux/api/dummyJson';
import moment from 'moment';

const BookingsChart = ({ dateList }) => {



    return (
        <div className='mt-4'>
            <p className="f3 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mb-0 primary">
                Bookings
            </p>
            <Bar
                data={{
                    labels: dateList?.booking_graph?.map((data) => moment(data.date).format("DD-MM-YYYY")),
                    datasets: [
                        {
                            label: "",
                            data: dateList?.booking_graph?.map((data) => data.total_bookings),
                            backgroundColor: [
                                "#6d9773",
                            ]
                        },
                    ],
                }}
            />

            <div className='mt-4'>
                <p className="f3 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mb-0 primary">
                    Bookings Amount
                </p>
                <Bar
                    data={{
                        labels:  dateList?.booking_graph?.map((data) => moment(data.date).format("DD-MM-YYYY")),
                        datasets: [
                            {
                                label: "",
                                data:  dateList?.booking_graph?.map((data) => data.total_booking_amount),
                                backgroundColor: [
                                    "#6d9773",
                                ]
                            },
                        ],
                    }}
                />


            </div >
            <div className='mt-4'>
                <p className="f3 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mb-0 primary">
                    MMC Amount
                </p>
                <Bar
                    data={{
                        labels:  dateList?.booking_graph?.map((data) => moment(data.date).format("DD-MM-YYYY")),
                        datasets: [
                            {
                                label: "",
                                data:  dateList?.booking_graph?.map((data) => data.total_mmc_amount),
                                backgroundColor: [
                                    "#6d9773",
                                ]
                            },
                        ],
                    }}
                />


            </div >

        </div >
    )
}

export default BookingsChart